import { mutate } from 'swr';

import { Project, ProjectUser, User } from 'models';
import { ProjectHelpers } from 'helpers/ProjectHelpers';

import { PayloadSDK } from './PayloadSDK';

const ProjectUserService = {
    list: async (projectId: Project['id']) => {
        const { docs } = await PayloadSDK.find({
            collection: 'projectUsers',
            where: {
                project: {
                    equals: projectId,
                },
            },
            sort: 'createdAt',
            depth: 0,
            pagination: false,
        });

        return docs as ProjectUser[];
    },

    follow: async (projectId: Project['id'], userId: User['id']) => {
        await PayloadSDK.create({
            collection: 'projectUsers',
            data: { project: projectId, user: userId },
        });

        await ProjectUserService.refresh(projectId);
    },

    unfollow: async (projectUser: ProjectUser) => {
        await PayloadSDK.delete({
            collection: 'projectUsers',
            id: projectUser.id,
        });

        await ProjectUserService.refresh(projectUser.project);
    },

    refresh: async (projectId: Project['id']) => {
        await mutate(ProjectHelpers.swr.users(projectId), await ProjectUserService.list(projectId), {
            revalidate: false,
        });
    },
};

export { ProjectUserService };
